import { formatText, TextRole } from '@pickleballinc/lib/format-text';

interface TimeCardProps {
  value: string;
  label: string;
}

export const TimeCard = ({ value, label }: TimeCardProps) => (
  <div className='flex flex-col px-[11px] py-[7px] sm:p-6 gap-1.5 sm:gap-3 items-center justify-center h-full min-h-[48px] w-[70px] md:min-h-[105px] md:w-[151px] border border-gray-200 rounded-lg sm:rounded-2xl bg-white shadow-lg sm:shadow-xl'>
    <span className='text-gray-900 text-2xl font-bold md:text-5xl sm:!tracking-[-0.96px] sm:!leading-[60px]'>
      {value}
    </span>
    <div className='h-px sm:h-[2px] w-[29px] sm:w-[62px] bg-gray-300' />
    <span className='text-xs sm:text-2xl text-gray-600 leading-[18px] sm:leading-[36px]'>
      {formatText({ text: label, role: TextRole.CardTitle })}
    </span>
  </div>
);
